import React from 'react';

// 现代化 wyzai Logo - 使用 intelligence.png 图片
export const WyzaiLogo = ({ size = 32, className = '' }) => (
  <img 
    src="/intelligence.png"
    alt="wyzai"
    width={size}
    height={size}
    className={className}
    style={{ borderRadius: '8px', objectFit: 'contain' }}
  />
);

// 简约版 Logo - 纯图标
export const WyzaiLogoSimple = ({ size = 32, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 40 40" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect 
      width="40" 
      height="40" 
      rx="10" 
      fill="url(#wyzai-simple-gradient)"
    />
    {/* API 风格的连接线 */}
    <path 
      d="M12 14h4l4 12 4-12h4" 
      stroke="white" 
      strokeWidth="2.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      fill="none"
    />
    <circle cx="12" cy="14" r="2" fill="white" />
    <circle cx="28" cy="14" r="2" fill="white" />
    <circle cx="20" cy="26" r="2" fill="white" />
    
    <defs>
      <linearGradient id="wyzai-simple-gradient" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
        <stop stopColor="#3B82F6" />
        <stop offset="1" stopColor="#6366F1" />
      </linearGradient>
    </defs>
  </svg>
);

// 带文字的 Logo 组合
export const WyzaiLogoWithText = ({ size = 32, fontSize = 18, className = '' }) => (
  <div className={`wyzai-logo-combo ${className}`} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
    <WyzaiLogo size={size} />
    <span style={{ 
      fontSize: `${fontSize}px`, 
      fontWeight: 600, 
      letterSpacing: '-0.02em',
      color: 'var(--text-primary)'
    }}>
      wyzai
    </span>
  </div>
);

export default WyzaiLogo;
